export default {
  'Resize for': 'Redimensionner pour',
  'Add 10 videos at most': 'Ajoutez au maximum 10 vidéos.',
}